<template>
  <div class="events-wrapper">
    <div v-if="isEventsLoading">
      <generic-loading-skeleton />
    </div>
    <div v-else>
      <div class="pb-2"><h2>Events</h2></div>
      <div v-if="events && events.length > 0">
        <div class="pt-1">
          <div v-for="event in events" :key="event.id">
            <div class="pb-2 pl-1">
              <event-card :event-data="event"></event-card>
            </div>
          </div>
        </div>
      </div>
      <div v-else>No events to display</div>
      <div class="d-flex justify-content-between">
        <a
          class="view-all-link"
          :href="allEventsLink"
          @click="trackViewAllClick('View all events selected')"
          target="_blank"
        >
          <span>View all</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";

import EventCard from "./EventCard";
import GenericLoadingSkeleton from "../GenericLoadingSkeleton";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "events",
  mixins: [HomebaseMixpanelMixin],
  components: {
    EventCard,
    GenericLoadingSkeleton,
  },
  data() {
    return {
      CONSTANTS,
      events: null,
      isEventsLoading: true,
      allEventsLink: CONSTANTS.ALL_EVENTS_LINK,
    };
  },
  created() {
    this.getEvents();
  },
  methods: {
    async getEvents() {
      this.isEventsLoading = true;
      let currentDateTime = new Date().toISOString();
      try {

        let res = await api.getTargetedEventsSites();
        let sitesList = res.value;
        let siteIdsList = sitesList.map(site => site.fields.SiteID);
        
        let eventsRes = await api.getTargetedEvents(currentDateTime, siteIdsList);
        let events = eventsRes.value[0].hitsContainers[0].hits;
        this.events = events.slice(0, 4);

      } catch (e) {
        // do nothing
      } finally {
        this.isEventsLoading = false;
      }
    },

    isLastIndex(arr, index) {
      if (!arr) return false;
      let lastIndex = arr.length - 1;
      return index === lastIndex;
    },
  },
};
</script>

<style scoped>
.events-wrapper {
  padding-bottom: 50px;
}

.add-event-link {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
}

.add-event-link:hover {
  color: #1f20bf;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/events/Events.vue